import apiClient from "@shared/config/axiosConfig";

const getPlantas = async () => {
  try {
    const response = await apiClient.get("/plantas");
    return response.data;
  } catch (error) {
    console.error("Error al obtener las plantas:", error);
    throw error;
  }
};

const getPlantaById = async (idPlanta) => {
  try {
    const response = await apiClient.get(`/plantas/${idPlanta}`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener la planta:", error);
    throw error;
  }
};

const createPlanta = async (planta) => {
  try {
    const response = await apiClient.post("/plantas", planta);
    return response.data;
  } catch (error) {
    console.error("Error al crear la planta:", error);
    throw error;
  }
};

const updatePlanoGeneral = async (idPlanta, plano_general_url) => {
  try {
    const response = await apiClient.put(`/plantas/${idPlanta}/plano-general`, {
      plano_general_url,
    });
    return response.data;
  } catch (error) {
    console.error("Error al actualizar plano general:", error);
    throw error;
  }
};

const updatePlanosHabilitados = async (idPlanta, habilitado) => {
  try {
    const response = await apiClient.put(
      `/plantas/${idPlanta}/planos-habilitados`,
      { habilitado },
    );
    return response.data;
  } catch (error) {
    console.error("Error al actualizar estado de planos:", error);
    throw error;
  }
};

const plantasService = {
  getPlantas,
  getPlantaById,
  createPlanta,
  updatePlanoGeneral,
  updatePlanosHabilitados,
};

export default plantasService;
